import { useTranslation } from '@crehana/i18n';
import { Container, Row } from '@crehana/ui';

import { SEOProps } from './types';
import LinksColumn from './LinksColumn';

const SEO: React.FC<SEOProps> = ({ seoData, isDark = true }) => {
  const { t } = useTranslation();

  return (
    <section className={`${isDark ? 'bg-base-dark' : 'bg-white'}`}>
      <Container>
        <Row className="py-32 sm:py-48 lg:py-64">
          <LinksColumn
            title={t('SEO_CATEGORIES_TITLE')}
            links={seoData.categories}
            className="mb-48 sm:mb-48 md:mb-0"
            isDark={isDark}
          />
          <LinksColumn
            title={t('SEO_SUBCATEGORIES_TITLE')}
            links={seoData.subcategories}
            className="mb-48 sm:mb-48 md:mb-0"
            isDark={isDark}
          />
          <LinksColumn
            title={t('SEO_SOFTWARES_TITLE')}
            links={seoData.softwares}
            className="mb-48 sm:mb-48 md:mb-0"
            isDark={isDark}
          />
          <LinksColumn
            title={t('SEO_TRACKS_TITLE')}
            links={seoData.specializations}
            isDark={isDark}
          />
        </Row>
      </Container>
    </section>
  );
};

export default SEO;
